export const API_ENDPOINT = 'cpd-points';


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/endpoints.js